import DetalheScreen from './DetalheScreen'

export default DetalheScreen
